// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:36.337056
var courses = [
    {
        "course_id": "EC1C00BA-0186-F111-99B9-005056A77B46",
        "course_version": 1,
        "name": "Lifebeat Solutions - National Essentials in Nursing Safety",
        "course_type": 32,
        "author_information": "",
        "description": "This Lifebeat Solutions nursing safety bundle is a curated library of courses to address key patient goals identified by national regulatory bodies. The areas of focus include effective staff communication, medication safety, alarms safety/responsiveness, prevent surgical errors, and reducing patient falls.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1FF15265-0186-F111-99B9-005056A77B46",
                "course_category_name": "Lifebeat Solutions - National Essentials in Nursing Safety - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "46DB20C5-CF70-F111-99B5-005056A7013F",
                "course_version": 3,
                "name": "Failure to Use Equipment in a Responsible Manner",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module builds competence in the safe use of healthcare equipment and devices. Learners identify risks associated with misuse, apply troubleshooting steps, and follow safety protocols \u2014 preventing device-related harm and reducing error-related adverse events in high-risk clinical environments.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the role of medical equipment in supporting patient safety.</li>\r\n    <li>Nurses demonstrate competency and apply training requirements for medical equipment use.</li>\r\n    <li>Nurses utilize early warning systems to support timely recognition of patient risk.</li>\r\n    <li>Nurses apply risk management strategies to prevent equipment-related harm.</li>\r\n    <li>Nurses identify the legal and ethical considerations associated with medical equipment use.</li>\r\n</ul>",
                "course_outline_html": "<h3>Failure to Use Equipment in a Responsible Manner</h3>\r\n<p>This course ensures safe and competent use of medical equipment to prevent avoidable patient harm.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Role of Medical Equipment in Patient Safety</li>\r\n    <li>Competency and Training</li>\r\n    <li>Early Warning Systems</li>\r\n    <li>Risk Management Strategies</li>\r\n    <li>Legal and Ethical Considerations</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Demonstrate equipment competency</li>\r\n    <li>Pass skills assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8985BD40-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Device Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4B8CE4E2-D6C9-E511-82AF-005056B150D3",
                        "course_category_name": "Medical Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CE9E1209-CE8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Diagnostic & Patient Monitoring Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F2374F68-D570-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Medication Error Management",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module strengthens nurses\u2019 ability to prevent, recognize, and respond to medication errors. Learners identify high-risk failure points, apply double-check systems, educate patients, and use root cause analysis to reduce harm \u2014 protecting patients through safer medication practices and interruption of error chains.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the most common causes and types of medication errors in clinical practice.</li>\r\n    <li>Nurses apply evidence-based strategies to prevent medication errors before they reach the patient.</li>\r\n    <li>Nurses implement safe medication administration practices to reduce error risk.</li>\r\n    <li>Nurses identify high-risk medications and patient populations requiring heightened vigilance.</li>\r\n    <li>Nurses apply reporting and root cause analysis principles to learn from medication errors.</li>\r\n</ul>",
                "course_outline_html": "<h3>Medication Error Management</h3>\r\n<p>This course focuses on identifying, preventing, and responding to medication errors to improve patient safety outcomes.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Medication Errors</li>\r\n    <li>Strategies for Preventing Medical Errors</li>\r\n    <li>Safe Medication Administration</li>\r\n    <li>High-Risk Medications &amp; Patient Populations</li>\r\n    <li>Reporting &amp; Learning from Medication Errors</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in medication safety scenarios</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "87DDC116-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Error Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5BC1344B-C570-F111-99B5-005056A7013F",
                "course_version": 3,
                "name": "Communication in Nursing Practice",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module elevates communication as a core clinical safety skill. Nurses learn structured tools like CUSS, strategies to overcome authority gradients, and patient-centered language that prevents errors and delays. By strengthening clinical escalation and team communication, this module reduces Failure to Rescue and protects both patients and nurses.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses apply structured communication skills to improve clarity and reduce error in nursing practice.</li>\r\n    <li>Nurses utilize interprofessional communication strategies to support coordinated patient care.</li>\r\n    <li>Nurses explain how communication failures contribute to adverse patient safety events.</li>\r\n    <li>Nurses apply effective communication strategies to overcome authority gradients and prevent delays.</li>\r\n    <li>Nurses implement patient-centered communication techniques to strengthen safety and engagement.</li>\r\n</ul>",
                "course_outline_html": "<h3>Communication in Nursing Practice</h3>\r\n<p>This course develops effective communication skills essential for patient safety and interprofessional collaboration.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Communication Skills for Nurses</li>\r\n    <li>Interprofessional Communication</li>\r\n    <li>Failure to Communicate: Impact on Patient Safety</li>\r\n    <li>Effective Communication Strategies</li>\r\n    <li>Patient-Centered Communication</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in communication scenarios</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Interpersonal Relationships",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CE9E1209-CE8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Diagnostic & Patient Monitoring Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Professional Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Effective Communication",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4B6E5A55-D270-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Managing Patient Aggression in Acute Care Settings",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module equips nurses with de-escalation strategies, personal safety techniques, and post-incident protocols for managing aggressive behavior. Learners enhance safety for patients and staff while reducing physical and psychological harm in high-stress clinical environments.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe factors contributing to the rise of aggression in healthcare settings.</li>\r\n    <li>Nurses recognize early signs and triggers of escalating patient aggression.</li>\r\n    <li>Nurses apply de-escalation skills to manage aggressive patient behavior safely.</li>\r\n    <li>Nurses implement strategies to maintain team safety during aggressive incidents.</li>\r\n    <li>Nurses apply post-incident recovery, reporting, and reform practices following an aggressive event.</li>\r\n</ul>",
                "course_outline_html": "<h3>Addressing Patient Suicide Risk in Acute Care Settings</h3>\r\n<p>This course focuses on identifying and managing suicide risk in acute care environments using evidence-based approaches.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Suicide Risk Factors and Warning Signs</li>\r\n    <li>Comprehensive Suicide Risk Assessment</li>\r\n    <li>Safety Plans and Crisis Interventions</li>\r\n    <li>Treatment Approaches</li>\r\n    <li>Postvention and Ongoing Support</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete suicide risk simulation</li>\r\n    <li>Pass final assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5FD53AE4-2326-E711-9EDE-005056B14F90",
                        "course_category_name": "Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "323AB59C-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "04403C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "411A8674-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Violence & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A9F0251D-B170-F111-99B5-005056A7013F",
                "course_version": 2,
                "name": "Addressing Patient Suicide Risk in Acute Care",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module trains nurses in identifying suicide risk, conducting safety planning, and coordinating multidisciplinary care. Learners use evidence-based screening tools and escalation pathways \u2014 strengthening early intervention and protecting vulnerable patients through proactive behavioral health vigilance.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses identify suicide risk factors and warning signs in the acute care setting.</li>\r\n    <li>Nurses conduct a comprehensive suicide risk assessment using evidence-based tools.</li>\r\n    <li>Nurses develop safety plans and implement crisis intervention strategies.</li>\r\n    <li>Nurses apply evidence-based treatment approaches for patients at risk for suicide.</li>\r\n    <li>Nurses implement postvention and ongoing support strategies following a suicide-related event.</li>\r\n</ul>",
                "course_outline_html": "<h3>Quality Improvement &amp; Clinical Audit in Nursing Practice</h3>\r\n<p>This course develops the nurse&rsquo;s ability to evaluate clinical practice, identify gaps in care, and contribute to continuous quality improvement initiatives that enhance patient safety and outcomes.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Quality Improvement in Healthcare</li>\r\n    <li>Principles of Clinical Audit and Performance Measurement</li>\r\n    <li>Identifying Gaps in Clinical Practice</li>\r\n    <li>Implementing Evidence-Based Improvement Strategies</li>\r\n    <li>Monitoring Outcomes and Sustaining Improvements</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in a quality improvement or audit simulation</li>\r\n    <li>Submit a basic improvement action plan</li>\r\n    <li>Pass final assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "04403C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "323AB59C-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Behavioral Health Challenges [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "45A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Psychiatry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                        "course_category_name": "Psychiatric Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "53C1ABED-D670-F111-99AE-005056A757F8",
                "course_version": 3,
                "name": "Medication Reconciliation and Discharge Planning",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module prepares nurses to ensure safe care transitions. Learners identify medication discrepancies, coordinate follow-up care, and strengthen patient understanding \u2014 reducing post-discharge complications and supporting continuity of care as a critical step in preventing Failure to Rescue.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the medication reconciliation process and its role in patient safety.</li>\r\n    <li>Nurses identify and resolve medication discrepancies during care transitions.</li>\r\n    <li>Nurses apply best practices for developing clear discharge instructions.</li>\r\n    <li>Nurses engage patients effectively in post-discharge care planning.</li>\r\n    <li>Nurses identify technology and innovation strategies that support safe discharge planning.</li>\r\n</ul>",
                "course_outline_html": "<h3>Medication Reconciliation and Discharge Planning</h3>\r\n<p>This course focuses on ensuring medication accuracy and safe transitions of care during discharge.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Understanding Medication Reconciliation</li>\r\n    <li>Resolving Medication Discrepancies</li>\r\n    <li>Best Practices for Discharge Instructions</li>\r\n    <li>Engaging Patients in Post-Discharge Care</li>\r\n    <li>Technology and Innovation in Discharge Planning</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete reconciliation exercise</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Care Coordination",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C118C362-7EE5-E511-BF27-005056B17F80",
                        "course_category_name": "Patient Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5B21433F-5F71-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Nursing Surveillance, Attentiveness and Vigilance",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module defines surveillance as the backbone of patient safety. Nurses learn how to prioritize subtle cues, recognize early deterioration, and intervene before crises occur \u2014 building sustainable vigilance without burnout and reducing Failure to Rescue through intentional, moment-to-moment clinical awareness.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses define surveillance, attentiveness, and vigilance as core components of patient safety.</li>\r\n    <li>Nurses apply effective nursing surveillance techniques to detect early signs of deterioration.</li>\r\n    <li>Nurses describe the role of attentiveness in sustaining safe nursing practice.</li>\r\n    <li>Nurses implement vigilance strategies that safeguard patient safety without contributing to burnout.</li>\r\n    <li>Nurses identify high-risk patients and situations requiring heightened surveillance.</li>\r\n</ul>",
                "course_outline_html": "<h3>Nursing Surveillance, Attentiveness, &amp; Vigilance</h3>\r\n<p>This course builds clinical vigilance skills to improve early detection of patient deterioration.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Surveillance, Attentiveness, &amp; Vigilance</li>\r\n    <li>Effective Nursing Surveillance</li>\r\n    <li>Role of Attentiveness in Nursing Practice</li>\r\n    <li>Vigilance: Safeguarding Patient Safety</li>\r\n    <li>Identifying High-Risk Patients &amp; Situations</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Participate in simulation exercises</li>\r\n    <li>Pass scenario-based assessment</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "934CE14D-6471-F111-99AF-005056A7F5E9",
                "course_version": 3,
                "name": "Sentinel and Never Events: Preventing Catastrophic Failures in Healthcare",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module equips nurses to recognize, report, and help prevent sentinel and never events. Through root cause analysis (RCA) principles and safety culture training, learners strengthen error prevention \u2014 supporting system resilience and advancing the mission of Zero Patient Harm.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses differentiate sentinel events from never events and their implications for patient safety.</li>\r\n    <li>Nurses apply root cause analysis principles to identify contributing factors and prevention strategies.</li>\r\n    <li>Nurses describe the role of accreditation and regulatory bodies in sentinel event oversight.</li>\r\n    <li>Nurses utilize reporting systems and transparency practices to support organizational learning.</li>\r\n    <li>Nurses describe the nurse's role in preventing sentinel and never events.</li>\r\n</ul>",
                "course_outline_html": "<h3>Sentinel and Never Events: Preventing Catastrophic Failures in Healthcare</h3>\r\n<p>This course explores systems-based prevention of catastrophic clinical failures and sentinel events.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction to Sentinel Events and Never Events</li>\r\n    <li>Root Cause Analysis and Prevention Strategies</li>\r\n    <li>Accreditation and Regulatory Bodies</li>\r\n    <li>Reporting Systems and Transparency</li>\r\n    <li>Nurse&rsquo;s Role in Prevention</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete RCA activity</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7088F23A-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Incident Reporting",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3B66D963-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Quality Assurance and Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                        "course_category_name": "All Settings",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "06F4A6DB-5F71-F111-99AF-005056A7F5E9",
                "course_version": 3,
                "name": "Postoperative Complications: Prevention and Management",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module prepares nurses to detect and respond to postoperative complications such as hemorrhage, pulmonary embolism, and acute kidney injury. Learners apply rapid assessment and intervention strategies \u2014 reducing Failure to Rescue by strengthening early recognition and timely bedside action.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses recognize early signs of postoperative hemorrhage and shock.</li>\r\n    <li>Nurses recognize early signs of postoperative respiratory and airway complications.</li>\r\n    <li>Nurses recognize early signs of postoperative cardiovascular, neurological, and anaphylactic emergencies.</li>\r\n    <li>Nurses identify risk factors and early indicators of acute kidney injury and other postoperative complications.</li>\r\n    <li>Nurses apply strategies for postoperative pain management, VTE prevention, and fall prevention.</li>\r\n</ul>",
                "course_outline_html": "<h3>Postoperative Complications: Prevention and Management</h3>\r\n<p>This course develops rapid recognition and response skills for postoperative complications.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Early Recognition of Hemorrhage and Shock</li>\r\n    <li>Respiratory and Airway Complications</li>\r\n    <li>Cardiovascular, Neurological, and Anaphylactic Emergencies</li>\r\n    <li>Acute Kidney Injury &amp; Other Complications</li>\r\n    <li>Pain Management, VTE Prevention, and Falls</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete emergency simulation</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3D3623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Perioperative Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7334B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgical Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0A5DE5F3-6071-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Preoperative Surgical Care",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module prepares nurses to ensure pre-operative safety through risk stratification, consent verification, site confirmation, and checklist compliance. Learners prevent surgical delays, errors, and wrong-site events by strengthening pre-procedure vigilance and communication \u2014 protecting patients before harm occurs.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses conduct a comprehensive preoperative patient evaluation.</li>\r\n    <li>Nurses apply principles of patient education and informed consent prior to surgical procedures.</li>\r\n    <li>Nurses implement preoperative checklists and safety protocols to prevent surgical errors.</li>\r\n    <li>Nurses apply preoperative risk assessment and stratification to guide patient preparation.</li>\r\n    <li>Nurses manage fasting status and medication considerations prior to surgery.</li>\r\n</ul>",
                "course_outline_html": "<h3>Preoperative Surgical Care</h3>\r\n<p>This course prepares nurses to deliver safe and effective preoperative care for surgical patients.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Patient Evaluation</li>\r\n    <li>Patient Education and Informed Consent</li>\r\n    <li>Checklists and Safety Protocols</li>\r\n    <li>Preoperative Risk Assessment and Stratification</li>\r\n    <li>Fasting and Medication Management</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all modules</li>\r\n    <li>Complete surgical safety checklist activity</li>\r\n    <li>Pass assessment quiz</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3D3623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Perioperative Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B667E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C118C362-7EE5-E511-BF27-005056B17F80",
                        "course_category_name": "Patient Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF67E4A2-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8D3F3C75-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: National Essentials in Nursing Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Medicine",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7334B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgical Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D92997B-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Error-Free Nursing Practice",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];